import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { ImageIcon } from 'lucide-react';
import { Dialog, DialogContent, DialogTitle, DialogDescription } from '@/components/ui/dialog';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

/**
 * Displays an uploaded task photo by id. Fetches the image as an authenticated
 * blob (img tags can't send auth headers) and shows a thumbnail; click to enlarge.
 */
const TaskPhotoThumb = ({ photoId, size = 'w-12 h-12' }) => {
  const [url, setUrl] = useState(null);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (!photoId) return;
    let revoked = null;
    let active = true;
    (async () => {
      try {
        const token = localStorage.getItem('token');
        const res = await axios.get(`${API}/uploads/${photoId}`, {
          headers: { Authorization: `Bearer ${token}` },
          responseType: 'blob',
        });
        if (!active) return;
        revoked = URL.createObjectURL(res.data);
        setUrl(revoked);
      } catch (e) {
        /* ignore — thumbnail just won't render */
      }
    })();
    return () => { active = false; if (revoked) URL.revokeObjectURL(revoked); };
  }, [photoId]);

  if (!photoId) return null;

  return (
    <>
      {url ? (
        <img
          src={url}
          alt="task"
          onClick={() => setOpen(true)}
          className={`${size} object-cover rounded-md border border-gray-200 cursor-pointer hover:opacity-80 transition-opacity`}
          data-testid={`task-photo-thumb-${photoId}`}
        />
      ) : (
        <div className={`${size} rounded-md border border-gray-200 bg-gray-50 flex items-center justify-center`}>
          <ImageIcon className="w-4 h-4 text-gray-300" />
        </div>
      )}
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent className="max-w-2xl p-2">
          <DialogTitle className="sr-only">Task photo</DialogTitle>
          <DialogDescription className="sr-only">Enlarged photo attached to a completed task</DialogDescription>
          {url && <img src={url} alt="task full" className="w-full h-auto rounded-md" />}
        </DialogContent>
      </Dialog>
    </>
  );
};

export default TaskPhotoThumb;
